import React from "react";
import style from "./SidePanel.module.css";

export default function SidePanel({ children, open, className = "" }) {
  return (
    <div className={`${style.container} ${className}`} data-open={open}>
      {children}
    </div>
  );
}
